export function redondear(num, decimales: number) {
  return (Math.round(num * 1000000) / 1000000).toFixed(decimales);
}

export function numeroaletorio(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}
